<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="openPurchaseReportFormModal()">
  <i nz-icon nzType="exception" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'PURCHASE_REPORT' | translate }}
  </span>
</button>
